import * as ToggleGroupPrimitive from '@radix-ui/react-toggle-group';

import { styled } from '@stitches/react';
import { COLORS } from '@lib/constants';

const borderRadius = 4;

const StyledToggleGroup = styled(ToggleGroupPrimitive.Root, {
  display: 'inline-flex',
  backgroundColor: COLORS.primary2,
  borderRadius: borderRadius,
  border: `1px solid ${COLORS.primary2}`,
  boxShadow: `0 2px 8px rgba(32, 35, 35, 0.1)`,
  cursor: 'pointer',
  fontFamily: 'Poppins'
});

const StyledItem = styled(ToggleGroupPrimitive.Item, {
  all: 'unset',
  backgroundColor: 'white',
  color: COLORS.primary2,
  display: 'flex',
  fontSize: 14,
  fontFamily: 'Poppins',
  lineHeight: 1,
  alignItems: 'center',
  justifyContent: 'center',
  padding: 10,
  marginLeft: 1,
  '&:first-child': {
    marginLeft: 0,
    borderTopLeftRadius: borderRadius,
    borderBottomLeftRadius: borderRadius
  },
  '&:last-child': {
    borderTopRightRadius: borderRadius,
    borderBottomRightRadius: borderRadius
  },
  '&:hover': {
    background: COLORS.primary2highlight,
    backdropFilter: 'blur(14px)',
    color: COLORS.white
  },
  '&[data-state=on]': {
    backgroundColor: COLORS.primary2,
    color: COLORS.white,
    textShadow: '0 2px 4px rgba(0, 0, 0, 0.35)'
  },
  '&[data-state=off]': {
    backgroundColor: COLORS.white,
    color: COLORS.primary2
  },
  '&:focus': { position: 'relative' }
});

export const ToggleGroup = StyledToggleGroup;
export const ToggleGroupItem = StyledItem;
